<div mat-dialog-title class="dialog-title-with-close-button">
  <h1 style="margin-top: 16px">{{ data.title }}</h1>
</div>

<orgbrain-loading-spinner></orgbrain-loading-spinner>
<mat-dialog-content class="info-box">
  <p class="mat-body">{{ data.body }}</p>
</mat-dialog-content>
